<template>
  <el-container class="layout-container">
    <el-aside :width="collapse ? '64px' : '210px'" class="layout-aside">
      <div class="logo">
        <span v-if="!collapse">小广场管理后台</span>
        <span v-else>小</span>
      </div>
      <Sidebar />
    </el-aside>
    <el-container>
      <el-header class="layout-header">
        <Navbar @toggle="toggleCollapse" />
      </el-header>
      <el-main class="layout-main">
        <router-view />
      </el-main>
    </el-container>
    <OrderNotifier />
  </el-container>
</template>

<script>
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
import OrderNotifier from '@/components/OrderNotifier'

export default {
  name: 'Layout',
  components: { Sidebar, Navbar, OrderNotifier },
  data () {
    return {
      collapse: false
    }
  },
  methods: {
    toggleCollapse (val) {
      this.collapse = val
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
}
.layout-aside {
  background: #304156;
  transition: width 0.2s;
  overflow: hidden;
}
.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  background: #263445;
  letter-spacing: 2px;
  overflow: hidden;
}
.layout-header {
  background: #fff;
  padding: 0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 1;
  height: 60px;
  line-height: 60px;
}
.layout-main {
  background: #f0f2f5;
  padding: 0;
  overflow-y: auto;
}
</style>
